import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { roomService } from '../services/roomService';

const { FiUsers, FiActivity, FiTrendingUp, FiRefreshCw } = FiIcons;

const RoomCounter = () => {
  const [totalRooms, setTotalRooms] = useState(1349);
  const [activeRooms, setActiveRooms] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  const fetchRoomStats = async () => {
    try {
      const [totalResult, activeResult] = await Promise.all([
        roomService.getTotalRoomCount(),
        roomService.getActiveRoomCount()
      ]);

      if (totalResult.success) setTotalRooms(totalResult.count);
      if (activeResult.success) setActiveRooms(activeResult.count);
    } catch (error) {
      console.error('Stats fetch error');
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchRoomStats();
    const interval = setInterval(fetchRoomStats, 15000); // Update every 15s for "live" feel
    return () => clearInterval(interval);
  }, []);

  const AnimatedNumber = ({ value }) => {
    const [displayValue, setDisplayValue] = useState(value);
    
    useEffect(() => {
      const step = Math.ceil((value - displayValue) / 10);
      if (step !== 0) {
        const timer = setTimeout(() => {
          setDisplayValue(prev => prev + step);
        }, 50);
        return () => clearTimeout(timer);
      }
    }, [value, displayValue]);

    return <span>{displayValue.toLocaleString()}</span>;
  };

  return (
    <motion.section 
      initial={{ opacity: 0, y: 20 }} 
      animate={{ opacity: 1, y: 0 }} 
      className="mb-16 bg-gradient-to-r from-primary-50 to-blue-50 rounded-2xl p-8 border border-primary-100"
    >
      <div className="text-center">
        <div className="w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <SafeIcon icon={FiTrendingUp} className="w-8 h-8 text-primary-600" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          🚀 Join Thousands of Users Already Sharing
        </h2>
        <div className="grid md:grid-cols-2 gap-6 max-w-2xl mx-auto">
          <div className="bg-white rounded-xl p-6 shadow-md border border-primary-100">
            <div className="flex items-center justify-center mb-2">
              <SafeIcon icon={FiUsers} className="w-6 h-6 text-primary-600 mr-2" />
              <span className="text-sm font-medium text-gray-600">Total Rooms Created</span>
            </div>
            <div className="text-3xl font-bold text-primary-600 mb-1">
              {isLoading ? '...' : <AnimatedNumber value={totalRooms} />}
            </div>
            <p className="text-xs text-gray-500">Growing every minute</p>
          </div>

          <div className="bg-white rounded-xl p-6 shadow-md border border-green-100">
            <div className="flex items-center justify-center mb-2">
              <SafeIcon icon={FiActivity} className="w-6 h-6 text-green-600 mr-2" />
              <span className="text-sm font-medium text-gray-600">Active Rooms</span>
            </div>
            <div className="text-3xl font-bold text-green-600 mb-1">
              {isLoading ? '...' : <AnimatedNumber value={activeRooms} />}
            </div>
            <p className="text-xs text-gray-500">Live right now</p>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default RoomCounter;